let MENU = {
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      // {
      //   title: "مدیریت سازمان ها",
      //   desc: "management of organizations",
      //   root: true,
      //   page: "orgs",
      // },
      // {
      //   title: "مدیریت دوره‌ها",
      //   desc: "management of courses",
      //   root: true,
      //   page: "my-courses",
      // },
    ],
  },
};

export default MENU;
